import React from 'react';
import Table from './CompanyCouponsTable';
import { PageHeader } from '../../common/index';
import { useNavigationContext } from '../../context/NavigationContext';

const { REACT_APP_BRAND } = process.env;

function CompanyCoupons(props) {
  const { company: companyId, agreement: agreementId, period } = props.match.params;

  const { setNavigationActivated } = useNavigationContext();
  React.useEffect(() => {
    setNavigationActivated(true);
  }, []);

  return (
    <div id="company-coupons">
      <PageHeader>
        <h1>Kuponger</h1>
        <h4>Här kan du:</h4>
        <ul>
          <li>Lägga till och hantera kuponger</li>
        </ul>
        <h6>Support?</h6>
        {REACT_APP_BRAND === 'CITY'
          ? <p><a href="mailto:info@cityhaftet.se">info@cityhaftet.se</a></p>
          : <p><a href="mailto:info@saenkelt.se">info@saenkelt.se</a></p>
        }
          
      </PageHeader>
      <Table companyId={companyId} agreementId={agreementId} period={period ? parseInt(period, 10) : null} />
    </div>
  );
}

export default CompanyCoupons;
